var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bProfile, useProfile } from '@brg/auth';
import PostCommentsContext from '../context/PostCommentsContext';
import { getChat } from '../../../../reducers/chatReducer';
import { fetchInitChatData, onUpdatePermissions } from '../../../../actions/chatActions';
import { CHAT_CLOSED_STATUS, COMMENT_INIT_OFFSET, COMMENTS_ALLOWED_TYPE } from '../const/const';
import useCommonProps from '../../../../hooks/useCommonProps';
import { getLongreadPosts } from '../../../../reducers/getLongReadPosts';
import urlApi from '../../../../actions/urlApi';
var PostCommentProvider = function (_a) {
    var children = _a.children;
    var dispatch = useDispatch();
    var profile = useProfile();
    var _b = useCommonProps(), commentsAllowed = _b.commentsAllowed, longreadId = _b.longreadId, longreadposts = _b.longreadposts, teamId = _b.teamId;
    var _c = useSelector(getChat), posts = _c.posts, loading = _c.loading, postsFetching = _c.postsFetching;
    var _d = useState(false), initialLoaded = _d[0], setInitialLoaded = _d[1];
    var hasFetched = useRef(false);
    var initOffset = true;
    var fetchInitiData = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(fetchInitChatData({
                entityId: '',
                entityType: COMMENTS_ALLOWED_TYPE.post,
                longreadId: longreadId,
                initOffset: true
            }));
            return [2 /*return*/];
        });
    }); };
    var fetchInitChatPermission = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, ((_a = urlApi()) === null || _a === void 0 ? void 0 : _a.fetchChatPermission(teamId).then(function (response) {
                        if (response.status === 200) {
                            return response.json();
                        }
                    }).then(function (team) {
                        var _a, _b, _c, _d, _e;
                        var isModer = profile && bProfile.isModer(profile);
                        var isOwner = profile &&
                            (((team === null || team === void 0 ? void 0 : team.ownersIDs) && ((_a = team === null || team === void 0 ? void 0 : team.ownersIDs) === null || _a === void 0 ? void 0 : _a.includes(profile === null || profile === void 0 ? void 0 : profile.accountId))));
                        var closedStatus = team && (team === null || team === void 0 ? void 0 : team.channelCommentClosedStatus);
                        var isChatClosed = closedStatus === CHAT_CLOSED_STATUS.close;
                        var channelOwner = team && ((_b = team === null || team === void 0 ? void 0 : team.owners) === null || _b === void 0 ? void 0 : _b[0]);
                        var isChatPause = closedStatus === CHAT_CLOSED_STATUS.pause;
                        var isPrivateChat = team && !!((_c = team === null || team === void 0 ? void 0 : team.channelCommentWhiteListIds) === null || _c === void 0 ? void 0 : _c.length) &&
                            !isChatClosed && !isChatPause;
                        var hasClosedMsg = team && !!(team === null || team === void 0 ? void 0 : team.channelCommentMsg);
                        var whiteListUser = profile && team && ((_d = team === null || team === void 0 ? void 0 : team.channelCommentWhiteListIds) === null || _d === void 0 ? void 0 : _d.includes(profile === null || profile === void 0 ? void 0 : profile.accountId));
                        var blackListUser = profile && (team && ((_e = team === null || team === void 0 ? void 0 : team.channelCommentBlackListIds) === null || _e === void 0 ? void 0 : _e.includes(profile === null || profile === void 0 ? void 0 : profile.accountId)));
                        var isWhiteList = (isChatClosed || isChatPause) ? false : (profile && whiteListUser) || isOwner || isModer;
                        var isBlackList = blackListUser && !isModer && !isOwner;
                        var permissions = {
                            entityType: COMMENTS_ALLOWED_TYPE.post,
                            longreadId: longreadId,
                            isBlackList: isBlackList,
                            isWhiteList: isWhiteList,
                            closedStatus: closedStatus,
                            channelOwner: channelOwner,
                            isPrivateChat: isPrivateChat,
                            // entityId: team?.teamId,
                            closedMsg: team === null || team === void 0 ? void 0 : team.channelCommentMsg,
                            isChatClosed: isChatClosed || isChatPause,
                        };
                        dispatch(onUpdatePermissions(__assign({}, permissions)));
                    }))];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var initData = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            hasFetched.current = true;
            fetchInitiData();
            fetchInitChatPermission();
            return [2 /*return*/];
        });
    }); };
    if (!commentsAllowed) {
        return children;
    }
    useEffect(function () {
        if (hasFetched.current || !teamId)
            return;
        initData();
    }, [hasFetched, hasFetched.current, teamId]);
    var contextValue = useMemo(function () { return ({
        posts: posts,
        loading: loading,
        postsFetching: postsFetching
    }); }, [
        posts,
        loading,
        postsFetching
    ]);
    return React.createElement(PostCommentsContext.Provider, { value: contextValue }, children);
};
export default PostCommentProvider;
//# sourceMappingURL=CommentProvider.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bProfile, useProfile } from '@brg/auth';
import PostCommentsContext from '../context/PostCommentsContext';
import { getChat } from '../../../../reducers/chatReducer';
import { fetchInitChatData, onUpdatePermissions } from '../../../../actions/chatActions';
import { CHAT_CLOSED_STATUS, COMMENT_INIT_OFFSET, COMMENTS_ALLOWED_TYPE } from '../const/const';
import useCommonProps from '../../../../hooks/useCommonProps';
import { getLongreadPosts } from '../../../../reducers/getLongReadPosts';
import urlApi from '../../../../actions/urlApi';
var PostCommentProvider = function (_a) {
    var children = _a.children;
    var dispatch = useDispatch();
    var profile = useProfile();
    var _b = useCommonProps(), commentsAllowed = _b.commentsAllowed, longreadId = _b.longreadId, longreadposts = _b.longreadposts, teamId = _b.teamId;
    var _c = useSelector(getChat), posts = _c.posts, loading = _c.loading, postsFetching = _c.postsFetching;
    var _d = useState(false), initialLoaded = _d[0], setInitialLoaded = _d[1];
    var hasFetched = useRef(false);
    var initOffset = true;
    var fetchInitiData = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(fetchInitChatData({
                entityId: '',
                entityType: COMMENTS_ALLOWED_TYPE.post,
                longreadId: longreadId,
                initOffset: true
            }));
            return [2 /*return*/];
        });
    }); };
    var fetchInitChatPermission = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, ((_a = urlApi()) === null || _a === void 0 ? void 0 : _a.fetchChatPermission(teamId).then(function (response) {
                        if (response.status === 200) {
                            return response.json();
                        }
                    }).then(function (team) {
                        var _a, _b, _c, _d, _e;
                        var isModer = profile && bProfile.isModer(profile);
                        var isOwner = profile &&
                            (((team === null || team === void 0 ? void 0 : team.ownersIDs) && ((_a = team === null || team === void 0 ? void 0 : team.ownersIDs) === null || _a === void 0 ? void 0 : _a.includes(profile === null || profile === void 0 ? void 0 : profile.accountId))));
                        var closedStatus = team && (team === null || team === void 0 ? void 0 : team.channelCommentClosedStatus);
                        var isChatClosed = closedStatus === CHAT_CLOSED_STATUS.close;
                        var channelOwner = team && ((_b = team === null || team === void 0 ? void 0 : team.owners) === null || _b === void 0 ? void 0 : _b[0]);
                        var isChatPause = closedStatus === CHAT_CLOSED_STATUS.pause;
                        var isPrivateChat = team && !!((_c = team === null || team === void 0 ? void 0 : team.channelCommentWhiteListIds) === null || _c === void 0 ? void 0 : _c.length) &&
                            !isChatClosed && !isChatPause;
                        var hasClosedMsg = team && !!(team === null || team === void 0 ? void 0 : team.channelCommentMsg);
                        var whiteListUser = profile && team && ((_d = team === null || team === void 0 ? void 0 : team.channelCommentWhiteListIds) === null || _d === void 0 ? void 0 : _d.includes(profile === null || profile === void 0 ? void 0 : profile.accountId));
                        var blackListUser = profile && (team && ((_e = team === null || team === void 0 ? void 0 : team.channelCommentBlackListIds) === null || _e === void 0 ? void 0 : _e.includes(profile === null || profile === void 0 ? void 0 : profile.accountId)));
                        var isWhiteList = (isChatClosed || isChatPause) ? false : (profile && whiteListUser) || isOwner || isModer;
                        var isBlackList = blackListUser && !isModer && !isOwner;
                        var permissions = {
                            entityType: COMMENTS_ALLOWED_TYPE.post,
                            longreadId: longreadId,
                            isBlackList: isBlackList,
                            isWhiteList: isWhiteList,
                            closedStatus: closedStatus,
                            channelOwner: channelOwner,
                            isPrivateChat: isPrivateChat,
                            // entityId: team?.teamId,
                            closedMsg: team === null || team === void 0 ? void 0 : team.channelCommentMsg,
                            isChatClosed: isChatClosed || isChatPause,
                        };
                        dispatch(onUpdatePermissions(__assign({}, permissions)));
                    }))];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var initData = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            hasFetched.current = true;
            fetchInitiData();
            fetchInitChatPermission();
            return [2 /*return*/];
        });
    }); };
    if (!commentsAllowed) {
        return children;
    }
    useEffect(function () {
        if (hasFetched.current || !teamId)
            return;
        initData();
    }, [hasFetched, hasFetched.current, teamId]);
    var contextValue = useMemo(function () { return ({
        posts: posts,
        loading: loading,
        postsFetching: postsFetching
    }); }, [
        posts,
        loading,
        postsFetching
    ]);
    return React.createElement(PostCommentsContext.Provider, { value: contextValue }, children);
};
export default PostCommentProvider;
//# sourceMappingURL=CommentProvider.js.map